import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import type { StateObject } from "../redux/types"
import type { CurrentPathType, RouterState } from "./reducer"
import type { MainMenuAgenda } from "./types"
import { MainMenuAgendaEnum } from "./types"

export const getRouterState = (state: StateObject): RouterState => state.router

export const getCurrentPath = (state: StateObject): CurrentPathType => getRouterState(state).currentPath

export const getCurrentPathName = (state: StateObject): Maybe<string> => getCurrentPath(state).pathname

export const getCurrentPathQuery = (state: StateObject): Record<string, Maybe<string>> => getCurrentPath(state).query

export const getRecordEditId = (state: StateObject): Maybe<string> => getCurrentPath(state).query.id || null

export const getRecordCreateId = (state: StateObject): Maybe<string> => getCurrentPath(state).query.add || null

export const isCreatingNewRecord = (state: StateObject): boolean => !!getRecordCreateId(state)

export const isDrawerOpened = (state: StateObject): boolean =>
    !!(getCurrentPath(state).query.id || getCurrentPath(state).query.add)

export const getCurrentAgenda = (state: StateObject): Maybe<MainMenuAgenda> => {
    const query = getCurrentPathQuery(state)

    if (!query.agenda) {
        return MainMenuAgendaEnum.SummaryReport
    }

    return query.agenda
}
